import {s_char} from "../../_signals/s_char";
import {Item} from "../CharStyled";
import React from "react";
import Button from "@mui/material/Button";
import CharCreate from "../../_helper/charcreate";
import updChar from "../../_sig_api/updChar";

export default function Karma() {

    const ritual = ()=> {
        updChar([{k:'karma',v:s_char.value.karma_max}])
    }

    return <Item>
        <div>Karma:</div>
        {s_char.value.karma} von {s_char.value.karma_max}
        {s_char.value.karma < s_char.value.karma_max && <Button
            style={{marginLeft:8,padding:0}} variant={'outlined'}
            onClick={()=>ritual()}
        >
            Ritual
        </Button>}
    </Item>
}